"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 35 35", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M35 17.5C35 27.165 27.165 35 17.499 35 7.835 35 0 27.166 0 17.5S7.835 0 17.499 0C27.165 0 35 7.834 35 17.5", fill: fill }),
            react_1.default.createElement("path", { d: "M12.796 12.4c1.002 0 2.298-.536 2.903-2.142l.664.202c-.377 1.376-1.849 2.86-3.952 2.673-1.485-.133-2.72-1.101-3.18-2.414-.579-1.643-.291-3.587 1.13-5.124 1.705-1.848 4.886-2.183 7.202-.781 2.108 1.273 3.38 3.281 4.973 3.328.465.014 1.36-.328 1.262-1.432-.096-1.14-1.844-2.176-3.628-1.145l-.34-.587c1.546-1.124 4.564-.608 5.042 1.994.246 1.326-.554 3.776-3.531 3.978-.45.357-.962 1.286-.962 2.305 0 .736.141 1.287.45 1.967.194-1.14 1.23-2.156 2.576-2.156 1.272 0 2.306.897 2.306 2.126 0 1.297-.93 2.006-1.85 2.006-.891 0-1.705-.759-1.705-1.623 0-.67.288-1.014.456-1.206.205-.234.495-.378.74-.43.076-.015.119-.012.119-.036.006-.075-.283-.13-.612-.06-.82.174-1.173.941-1.273 1.214-.122.329-.176.884-.073 1.422.165.85.643 1.615.946 2.16.575 1.026 1.69 3.09 1.562 5.386-.067 1.202-.409 2.23-.997 3.3-.895 1.641-3.225 3.396-6.031 3.396-2.851 0-5.573-1.495-6.54-4.528a7.014 7.014 0 01.262-4.873c.337-.785.773-1.445 1.342-2.335.231-.364.654-1.079.654-1.647 0-.904-.617-1.06-.951-1.018-.883.103-1.78 1.386-1.18 3.027l-.626.258c-.722-1.565-.074-3.546 1.584-4.077 1.438-.46 3.062.343 3.666 1.769.883 2.074-.433 4.115-1.058 5.36-2.08 4.148-.038 7.327 2.847 7.327 2.939 0 4.716-3.256 2.902-7.177-1.07-2.317-2.428-4.512-2.358-6.928.07-2.31 1.314-3.914 3.049-4.997-3.456-.43-5.103-3.312-7.242-3.977-.429-.133-1.63-.31-2.537.459-.69.585-1.208 1.736-.754 3.108.366 1.119 1.498 1.929 2.743 1.929", fill: "#FFF" }))));
};
var Fvn = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#1C1E57' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill }, rest));
};
exports.default = Fvn;
